//---------------Stage Config--------------------

let config = {
  AdminAPIURL: "https://jc2-admin-api.stage.jewelcloud.com/api",
  DealerAPIURL: "https://jc2-dlr-api.stage.jewelcloud.com/api",
  CatalogAPIURL: "https://jc2-ctlg-api.stage.jewelcloud.com/api",
  CommunityAPIURL: "https://jc2-cmnt-api.stage.jewelcloud.com/api",
  AppsAPIURL: "https://jc2-apps-api.stage.jewelcloud.com/api",
  PurchaseOrderAPIURL: "https://jc2-ipo-api.stage.jewelcloud.com/api",
  MarketingUploadAPIURL: "https://jc2-mrktg-api.stage.jewelcloud.com/api",
  AdminReportURL: "https://jc2-report-api.stage.jewelcloud.com/api",
  IdleTimer: 3600000,
  // Iframe URLs for Apps
  GemstoneLinkURL: "http://jc2-gslink.stage.jewelcloud.com",
  StudBuilderURL: "https://jc2-sbuild.stage.jewelcloud.com",
  RingBuilderURL: "https://jc2-rbuild.stage.jewelcloud.com",
  PendantBuilderURL: "https://jc2-pbuild.stage.jewelcloud.com",
  DiamondLinkURL: "https://jc2-dlink.stage.jewelcloud.com",
  MasterLinkURL: "https://jc2-mstlink.stage.jewelcloud.com",
  WatchCustomizerURL: "https://jc2-wtchcustmizer.mgr.brainvire.net",
  BlobURL: "https://jewelcloudstagingdiag.blob.core.windows.net/",
  ImageURL: "https://media.jewelcloud.com/"
};

export default config;
